var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"legend"},[_c('h2',[_vm._v(_vm._s(_vm.legendTitle))]),_vm._l((_vm.pins),function(pin){return _c('LegendCategory',{key:pin._id,attrs:{"pin":pin,"colortheme":_vm.colorTheme},on:{"click":_vm.click}})}),_c('div',{staticClass:"legend-background"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }